import { combineReducers } from "redux";
import authReducer, { AuthState } from "./authReducer";
import caseReducer, { CaseState } from "./caseReducer";
import reportLockReducer, { ReportLockState } from "./reportLockReducer";
import inAppNotificationReducer, {
  InAppNotificationState,
} from "./inAppNotificationReducer";

export interface RootReducerProps {
  auth: AuthState;
  caseDetail: CaseState;
  reportLock: ReportLockState;
  inAppNotifications: InAppNotificationState;
}

const RootReducer = combineReducers<RootReducerProps>({
  auth: authReducer,
  caseDetail: caseReducer,
  reportLock: reportLockReducer,
  inAppNotifications: inAppNotificationReducer,
});

export default RootReducer;
